var _path, _path2, _path3, _path4, _path5, _rect, _path6, _rect2, _rect3, _rect4, _path7, _path8, _rect5, _rect6, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4361 11.3453C22.4121 12.458 24.0873 15.6214 23.3365 18.7107C22.5857 21.8001 19.6459 23.8401 16.4918 23.4605C13.3377 23.081 10.965 20.4016 10.9673 17.2222C10.9652 16.4104 11.1223 15.606 11.4296 14.8547C12.0637 13.3041 13.2882 12.0698 14.8329 11.4241C15.4032 11.1893 16.0045 11.0384 16.6181 10.9762H17.8575C18.3967 11.035 18.9267 11.1589 19.4361 11.3453Z",
    fill: "#00EFD1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4361 7.10743V10.986H17.8624C17.6607 10.9663 17.4492 10.9565 17.2427 10.9565C17.0312 10.9565 16.8247 10.9663 16.623 10.986H14.8378V7.10743H19.4361Z",
    fill: "#E0E0E2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.96398 7.10743H0.48694V3.24362C0.486534 3.01244 0.578116 2.79061 0.741453 2.62714C0.90479 2.46367 1.12644 2.37202 1.35743 2.37242H3.00005V4.51351H6.02956V2.37242H13.8836V4.51351H16.9181V2.37242H18.5607C18.7917 2.37202 19.0133 2.46367 19.1767 2.62714C19.34 2.79061 19.4316 3.01244 19.4312 3.24362V7.10251H9.96398V7.10743Z",
    fill: "#00ACEA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9181 2.37242V4.51843H13.8885V2.37242V0.511887H16.9181V2.37242Z",
    fill: "#00EFD1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8328 11.429C13.2861 12.0718 12.0607 13.3071 11.4296 14.8597H9.96399V10.9811H14.8378V11.429H14.8328Z",
    fill: "#E0E0E2"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.96399,
    y: 7.10743,
    width: 4.87377,
    height: 3.87857,
    fill: "#D4E1F4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4296 14.8596C10.8834 16.2075 10.8191 17.7028 11.2476 19.0926H9.96399V14.8646H11.4296V14.8596Z",
    fill: "#D4E1F4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.08533,
    y: 14.8596,
    width: 4.87377,
    height: 4.22804,
    fill: "#E0E0E2"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 5.08533,
    y: 10.9811,
    width: 4.87377,
    height: 3.87857,
    fill: "#D4E1F4"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 5.08533,
    y: 7.10743,
    width: 4.87377,
    height: 3.87857,
    fill: "#E0E0E2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.03451 2.37242V4.51843H3.005V2.37242V0.511887H6.03451V2.37242Z",
    fill: "#00EFD1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5.0853 14.8596V19.0877H1.35743C1.12644 19.0881 0.90479 18.9964 0.741453 18.833C0.578116 18.6695 0.486534 18.4477 0.48694 18.2165V14.8596H5.0853Z",
    fill: "#D4E1F4"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 0.486938,
    y: 10.9811,
    width: 4.59836,
    height: 3.87857,
    fill: "#E0E0E2"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 0.486938,
    y: 7.10743,
    width: 4.59836,
    height: 3.87857,
    fill: "#D4E1F4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.918 11.0155V3.24363C19.9218 2.49134 19.3172 1.87752 18.5656 1.87038H17.4098V0.511893C17.4098 0.24118 17.1934 0 16.918 0H13.8836C13.6047 0.00843621 13.3806 0.232751 13.3721 0.511893V1.87038H6.541V0.511893C6.53487 0.233663 6.31238 0.00882528 6.03444 0H3.00494C2.72824 0.0079916 2.5081 0.23485 2.50822 0.511893V1.87038H1.3574C0.604776 1.87708 -0.00141076 2.49036 2.44901e-05 3.24363V18.2165C-0.00313734 18.9705 0.60405 19.5848 1.3574 19.5897H10.8935C11.3459 20.771 12.1476 21.8785 13.1853 22.6562C14.3538 23.5339 15.7767 24.0057 17.2377 23.9999C20.9656 23.9999 24 20.963 24 17.2272C23.9991 14.5271 22.3949 12.0859 19.918 11.0155ZM16.5984 10.484H15.3443V7.57995H18.9344V10.484H17.882C17.4555 10.4347 17.0248 10.4347 16.5984 10.484ZM14.3607 10.484V7.57995H10.4754V10.484H14.3607ZM9.49182 10.484H5.5574V7.57995H9.49182V10.484ZM0.98363 10.484H4.57379V7.57995H0.98363V10.484ZM4.57379 11.4684V14.3724H0.98363V11.4684H4.57379ZM9.49182 11.4684H5.5574V14.3724H9.49182V11.4684ZM9.49182 15.3568V18.6053H5.5574V15.3568H9.49182ZM10.741 15.3568H10.4754V17.1924C10.4775 16.5712 10.5669 15.9532 10.741 15.3568ZM10.4754 17.237V18.6053H10.6131C10.5225 18.1548 10.4764 17.6965 10.4754 17.237ZM10.4754 14.3724V11.4684H13.6771C12.5609 12.1715 11.6685 13.179 11.1049 14.3724H10.4754ZM16.4262 0.984409H14.3607V4.03608H16.4262V0.984409ZM3.49182 0.984409H5.5574V4.03608H3.49182V0.984409ZM2.50822 2.85479H1.3574C1.14813 2.86166 0.982398 3.03408 0.98363 3.24363V6.59554H18.9344V3.24363C18.9397 3.03437 18.7747 2.86037 18.5656 2.85479H17.4098V4.51844C17.4099 4.79191 17.1912 5.01512 16.918 5.02049H13.8885C13.6115 5.01664 13.3863 4.79562 13.3771 4.51844V2.85479H6.541V4.51844C6.53407 4.79469 6.31053 5.01624 6.03444 5.02049H3.00494C2.73006 5.0172 2.50879 4.79356 2.50822 4.51844V2.85479ZM0.98363 18.2165V15.3568H4.57379V18.6053H1.3574C1.14738 18.6001 0.980682 18.4267 0.98363 18.2165ZM13.7803 21.8637C14.7787 22.6141 15.9941 23.0184 17.2426 23.0155C20.4295 23.0155 23.0213 20.4166 23.0262 17.2222C23.024 14.2576 20.7842 11.7737 17.8377 11.4684H16.6525C16.0934 11.5215 15.5459 11.661 15.0295 11.8818C13.6064 12.4797 12.4781 13.6178 11.8918 15.0467C11.388 16.2876 11.3272 17.6644 11.7197 18.945C12.0832 20.1103 12.8042 21.1316 13.7803 21.8637Z",
    fill: "#36378C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7377 15.6964L16.7213 17.7144L15.7426 16.7251C15.6196 16.6003 15.4394 16.5506 15.2699 16.5947C15.1004 16.6389 14.9672 16.7703 14.9207 16.9393C14.8742 17.1083 14.9213 17.2893 15.0443 17.4142L16.3721 18.753C16.4646 18.8456 16.5905 18.897 16.7213 18.8957C16.8521 18.897 16.978 18.8456 17.0705 18.753L19.4361 16.3855C19.5281 16.2935 19.5799 16.1687 19.5799 16.0385C19.5799 15.9083 19.5281 15.7834 19.4361 15.6915C19.2414 15.5009 18.9296 15.5031 18.7377 15.6964Z",
    fill: "#083863"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.853bae410362897f694930ab5a4312b1.svg";
export { ForwardRef as ReactComponent };